export default {
  CODE852: "+852 香港",
  CODE853: "+853 澳门",
  CODE86: "+86 中国内地",
  CODE886: "+886 台湾",
  CODE1: "+1 北美洲",
  CODE7: "+7 俄罗斯",
  CODE20: "+20 埃及",
  CODE27: "+27 南非",
  CODE30: "+30 希腊",
  CODE31: "+31 荷兰",
  CODE32: "+32 比利时",
  CODE33: "+33 法国",
  CODE34: "+34 西班牙",
  CODE36: "+36 匈牙利",
  CODE39: "+39 义大利",
  CODE40: "+40 罗马尼亚",
  CODE41: "+41 瑞士",
  CODE43: "+43 奥地利",
  CODE44: "+44 英国",
  CODE45: "+45 丹麦",
  CODE46: "+46 瑞典",
  CODE47: "+47 挪威",
  CODE48: "+48 波兰",
  CODE49: "+49 德国",
  CODE51: "+51 秘鲁",
  CODE52: "+52 墨西哥",
  CODE53: "+53 古巴",
  CODE54: "+54 阿根廷",
  CODE55: "+55 巴西",
  CODE56: "+56 智利 / 复活节岛",
  CODE57: "+57 哥伦比亚",
  CODE58: "+58 委内瑞拉",
  CODE60: "+60 马来西亚",
  CODE61: "+61 澳大利亚",
  CODE62: "+62 印尼",
  CODE63: "+63 菲律宾",
  CODE64: "+64 新西兰",
  CODE65: "+65 新加坡",
  CODE66: "+66 泰国",
  CODE81: "+81 日本",
  CODE82: "+82 南韩",
  CODE84: "+84 越南",
  CODE90: "+90 土耳其",
  CODE91: "+91 印度",
  CODE92: "+92 巴基斯坦",
  CODE93: "+93 阿富汗",
  CODE94: "+94 斯里兰卡",
  CODE95: "+95 缅甸",
  CODE98: "+98 伊朗",
  CODE211: "+211 南苏丹",
  CODE212: "+212 摩洛哥",
  CODE213: "+213 阿尔及利亚",
  CODE216: "+216 突尼西亚",
  CODE218: "+218 利比亚",
  CODE220: "+220 冈比亚",
  CODE221: "+221 塞内加尔",
  CODE222: "+222 毛里塔尼亚",
  CODE223: "+223 马里",
  CODE224: "+224 几内亚",
  CODE225: "+225 科特迪瓦",
  CODE226: "+226 布吉纳法索",
  CODE227: "+227 尼日尔",
  CODE228: "+228 多哥",
  CODE229: "+229 贝南",
  CODE230: "+230 模里西斯",
  CODE231: "+231 利比里亚",
  CODE232: "+232 塞拉利昂",
  CODE233: "+233 加纳",
  CODE234: "+234 奈及利亚",
  CODE235: "+235 乍得",
  CODE236: "+236 中非",
  CODE237: "+237 喀麦隆",
  CODE238: "+238 佛得角",
  CODE239: "+239 圣多美和普林西比",
  CODE240: "+240 赤道几内亚",
  CODE241: "+241 加彭",
  CODE242: "+242 刚果共和国",
  CODE243: "+243 刚果民主共和国",
  CODE244: "+244 安哥拉",
  CODE245: "+245 几内亚比绍",
  CODE246: "+246 英属印度洋领地（英国）",
  CODE247: "+247 阿森松（英国）",
  CODE248: "+248 塞舌尔",
  CODE249: "+249 苏丹",
  CODE250: "+250 卢旺达",
  CODE251: "+251 衣索比亚",
  CODE252: "+252 索马里",
  CODE253: "+253 吉布提",
  CODE254: "+254 肯尼亚",
  CODE255: "+255 坦桑尼亚 / 尚吉巴",
  CODE256: "+256 乌干达",
  CODE257: "+257 蒲隆地",
  CODE258: "+258 莫桑比克",
  CODE260: "+260 尚比亚",
  CODE261: "+261 马达加斯加",
  CODE262: "+262 马约特 / 留尼汪",
  CODE263: "+263 辛巴威",
  CODE264: "+264 纳米比亚",
  CODE265: "+265 马拉维",
  CODE266: "+266 赖索托",
  CODE267: "+267 博茨瓦纳",
  CODE268: "+268 斯威士兰",
  CODE269: "+269 科摩罗",
  CODE290: "+290 圣海伦娜（英国）",
  CODE291: "+291 厄立特里亚",
  CODE297: "+297 阿鲁巴（荷兰）",
  CODE298: "+298 法罗群岛（丹麦）",
  CODE299: "+299 格陵兰（丹麦）",
  CODE350: "+350 直布罗陀（英国）",
  CODE351: "+351 葡萄牙",
  CODE352: "+352 卢森堡",
  CODE353: "+353 爱尔兰",
  CODE354: "+354 冰岛",
  CODE355: "+355 阿尔巴尼亚",
  CODE356: "+356 马尔他",
  CODE357: "+357 赛普勒斯",
  CODE358: "+358 芬兰",
  CODE359: "+359 保加利亚",
  CODE370: "+370 立陶宛",
  CODE371: "+371 拉脱维亚",
  CODE372: "+372 爱沙尼亚",
  CODE373: "+373 摩尔多瓦",
  CODE374: "+374 亚美尼亚",
  CODE375: "+375 白俄罗斯",
  CODE376: "+376 安道尔",
  CODE377: "+377 摩纳哥",
  CODE378: "+378 圣马力诺",
  CODE379: "+379 梵蒂冈",
  CODE380: "+380 乌克兰",
  CODE381: "+381 塞尔维亚",
  CODE382: "+382 蒙特内哥罗",
  CODE385: "+385 克罗地亚",
  CODE386: "+386 斯洛维尼亚",
  CODE387: "+387 波士尼亚与赫塞哥维纳",
  CODE389: "+389 马其顿",
  CODE420: "+420 捷克",
  CODE421: "+421 斯洛伐克",
  CODE423: "+423 列支敦斯登",
  CODE500: "+500 英国海外领土（英国）",
  CODE501: "+501 伯利兹",
  CODE502: "+502 危地马拉",
  CODE503: "+503 萨尔瓦多",
  CODE504: "+504 洪都拉斯",
  CODE505: "+505 尼加拉瓜",
  CODE506: "+506 哥斯达黎加",
  CODE507: "+507 巴拿马",
  CODE508: "+508 圣皮埃尔和密克隆（法国）",
  CODE509: "+509 海地",
  CODE590: "+590 法国海外领土（法国）",
  CODE591: "+591 玻利维亚",
  CODE592: "+592 圭亚那",
  CODE593: "+593 厄瓜多尔",
  CODE594: "+594 法属圭亚那（法国）",
  CODE595: "+595 巴拉圭",
  CODE596: "+596 法属安的列斯（法国）",
  CODE597: "+597 苏里南",
  CODE598: "+598 乌拉圭",
  CODE599: "+599 荷兰加勒比区（荷兰）",
  CODE670: "+670 东帝汶",
  CODE672: "+672 澳大利亚海外领土（澳大利亚）",
  CODE673: "+673 汶莱",
  CODE674: "+674 瑙鲁",
  CODE675: "+675 巴布亚新几内亚",
  CODE676: "+676 东加",
  CODE677: "+677 所罗门群岛",
  CODE678: "+678 瓦努阿图",
  CODE679: "+679 斐济",
  CODE680: "+680 帛琉",
  CODE681: "+681 瓦利斯和富图纳（法国）",
  CODE682: "+682 库克群岛（新西兰）",
  CODE683: "+683 纽埃（新西兰）",
  CODE685: "+685 萨摩亚",
  CODE686: "+686 基里巴斯",
  CODE687: "+687 新喀里多尼亚（法国）",
  CODE688: "+688 图瓦卢",
  CODE689: "+689 法属玻里尼西亚（法国）",
  CODE690: "+690 托克劳（新西兰）",
  CODE691: "+691 密克罗尼西亚联邦",
  CODE692: "+692 马绍尔群岛",
  CODE800: "+800 国际免费电话",
  CODE808: "+808 国际费用分担业务",
  CODE850: "+850 北韩",
  CODE855: "+855 柬埔寨",
  CODE856: "+856 老挝",
  CODE870: "+870 国际海事卫星组织",
  CODE878: "+878 环球个人通讯服务",
  CODE880: "+880 孟加拉国",
  CODE881: "+881 移动卫星系统",
  CODE882: "+882 国际网络",
  CODE883: "+883 国际网络",
  CODE888: "+888 联合国人权事务协调办公室",
  CODE960: "+960 马尔地夫",
  CODE961: "+961 黎巴嫩",
  CODE962: "+962 约旦",
  CODE963: "+963 叙利亚",
  CODE964: "+964 伊拉克",
  CODE965: "+965 科威特",
  CODE966: "+966 沙乌地阿拉伯",
  CODE967: "+967 叶门",
  CODE968: "+968 阿曼",
  CODE970: "+970 巴勒斯坦",
  CODE971: "+971 阿联酋",
  CODE972: "+972 以色列",
  CODE973: "+973 巴林",
  CODE974: "+974 卡达",
  CODE975: "+975 不丹",
  CODE976: "+976 蒙古国",
  CODE977: "+977 尼泊尔",
  CODE979: "+979 国际额外费用",
  CODE992: "+992 塔吉克",
  CODE993: "+993 土库曼",
  CODE994: "+994 阿塞拜疆",
  CODE995: "+995 乔治亚",
  CODE996: "+996 吉尔吉斯",
  CODE998: "+998 乌兹别克",
};
